export default __webpack_public_path__ + "static/media/Vatrina.e9b3f288.png";